import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

import { SwitchToOrganisationDocument } from 'graphql/types';
import { isLoggingOutVar } from 'graphql/apolloClient';
import { useApolloError } from 'common/hooks/useApolloError';
import { useSnackbar } from 'common/hooks/useSnackbar';

export const useSwitchOrganisation = () => {
    const [translate] = useTranslation();
    const { showApolloError } = useApolloError();
    const [displaySnackbar] = useSnackbar();
    const [switchToOrganisation, { loading }] = useMutation(
        SwitchToOrganisationDocument
    );

    const switchOrganisation = useCallback(
        async (organisationId: string) => {
            isLoggingOutVar(true);

            try {
                const result = await switchToOrganisation({
                    variables: { organisationId },
                });

                const loginUrl = result.data?.switchToOrganisation?.loginUrl;

                if (loginUrl) {
                    window.location.href = loginUrl;

                    return;
                }

                displaySnackbar(translate('switchOrganisationFailed'), {
                    variant: 'error',
                });
            } catch (error) {
                showApolloError(error);
            }

            isLoggingOutVar(false);
        },
        [switchToOrganisation, showApolloError, displaySnackbar, translate]
    );

    return { switchOrganisation, loading };
};
